module.exports = __webpack_public_path__ + "static/media/step-payout-icon.5ea2ca3f.svg";